import { useQuery } from '@tanstack/react-query';
import { getStoredMe } from '@/lib/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Authenticated tenant profile (name, email, site_key).
 * Seeds from localStorage (written at login) so the embed snippet renders
 * instantly, then confirms against /api/auth/me.
 */
export function useMe() {
  const { data } = useQuery({
    queryKey: ['me'],
    queryFn: () => fetch(`${BACKEND_URL}/api/auth/me`).then(r => {
      if (!r.ok) throw new Error('Failed to load profile');
      return r.json();
    }),
    // placeholderData (not initialData!) — paints instantly from localStorage
    // but still fetches immediately, so fields added after login appear.
    placeholderData: getStoredMe() || undefined,
    staleTime: 60_000,
    enabled: !!localStorage.getItem('tether_auth'),
  });
  return data || null;
}
